import { createApp } from 'vue'
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'
import App from './App.vue'
import AppSvg from './components/AppSvg.vue'
import router from './router'
import './assets/styles/main.scss'

const app = createApp(App).use(router)

app.component('AppSvg', AppSvg).component('DotLottieVue', DotLottieVue)

app.mount('#app')
